import { forwardRef } from 'react';
import { m, useReducedMotion } from 'framer-motion';

import Box from '@mui/material/Box';

import { useResponsive } from 'src/hooks/use-responsive';

import { varContainer } from './variants';

export const MotionViewport = forwardRef(({ children, disableAnimate = true, ...other }, ref) => {
  const smDown = useResponsive('down', 'sm');
  const reduceMotion = useReducedMotion();

  const disabled = reduceMotion || (smDown && disableAnimate);

  const props = disabled
    ? {}
    : {
        component: m.div,
        initial: 'initial',
        whileInView: 'animate',
        variants: varContainer(),
        viewport: { once: true, amount: 0.3 },
      };

  return (
    <Box ref={ref} {...props} {...other}>
      {children}
    </Box>
  );
});
